import { styled } from '@mui/material/styles';
import { ChevronDown } from '@styled-icons/bootstrap';
import { ICellRendererParams } from 'ag-grid-community';
import React, { FC } from 'react';
import { IExcelTableContext } from '../excelTable.types';
import { TFarmColumns } from 'FeatureModules/DataImport/types/dataImport.types';

const DropdownCellContainer = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
});

const DropdownCellContent = styled('div')({
  flex: 1,
  textAlign: 'left',
  overflowX: 'hidden',
  textOverflow: 'ellipsis',
});

const DropdownCellRenderer: FC<ICellRendererParams<TFarmColumns, string, IExcelTableContext>> = ({
  value,
  context,
}) => {
  return (
    <DropdownCellContainer>
      {value && <DropdownCellContent>{value}</DropdownCellContent>}
      <ChevronDown size={16} color={context.theme.custom.themeColors.grayScale[40]} />
    </DropdownCellContainer>
  );
};

export default DropdownCellRenderer;
